var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"href":"","target":"_blank","text":""}},[_c('span',{staticClass:"mr-2 hidden-sm-and-down",on:{"click":function($event){_vm.dialogoArchivo = true}}},[_vm._v("LECTOR EXCEL")])])}
var staticRenderFns = []

export { render, staticRenderFns }